// extracted by mini-css-extract-plugin
module.exports = {"textSection":"text-section-module--textSection--2rceL","callButton":"text-section-module--callButton--188sq"};